import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { Head, Page } from "@sprout/client-layout";
import getFullName from "@sprout/client-lib/dist/getFullName";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { Glitch, NotFound } from "@sprout/views";
import { useParams } from "react-router-dom";
import { useProfilePageUserQuery, UserType } from "sprout-graphql";
import ProfilePageUserAppBarMobile from "./ProfilePageUserAppBarMobile";
import ProfilePageUserHeader from "./ProfilePageUserHeader";
import ProfilePageUserPosts from "./ProfilePageUserPosts";
import ProfilePageUserToolbar from "./ProfilePageUserToolbar";
import ProfilePageUserTopics from "./ProfilePageUserTopics";
const ProfilePageUser = ()=>{
    const { username  } = useParams();
    const { data , loading , error  } = useProfilePageUserQuery({
        variables: {
            username
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
    const currentUser = useCurrentUser();
    const user = data === null || data === void 0 ? void 0 : data.user;
    useLoadingProgress(loading && !user);
    if (loading && !user) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!user) return /*#__PURE__*/ _jsx(NotFound, {});
    const isCurrentUser = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === user.id;
    const fullName = getFullName(user);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: UserType.User,
                data: {
                    userId: user.id
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: isCurrentUser ? "Profile | Sprout" : `${fullName ? `${fullName} (${username})` : username}`,
                description: user.bio,
                image: user.avatar,
                type: "profile"
            }),
            /*#__PURE__*/ _jsx(ProfilePageUserAppBarMobile, {
                user: user
            }),
            /*#__PURE__*/ _jsxs(Page, {
                variant: "normal",
                offsetWithPadding: "16px",
                maxWidth: 1080,
                toolbar: /*#__PURE__*/ _jsx(ProfilePageUserToolbar, {
                    user: user
                }),
                children: [
                    /*#__PURE__*/ _jsx(ProfilePageUserHeader, {
                        user: user
                    }),
                    /*#__PURE__*/ _jsx(ProfilePageUserTopics, {
                        user: user
                    }),
                    /*#__PURE__*/ _jsx(ProfilePageUserPosts, {
                        user: user
                    })
                ]
            })
        ]
    });
};
export default ProfilePageUser;
